import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import './eiq-live-activity.scss';
import eiqManageLiveActivityStore from 'features/eiq-manage/stores/live-activity.store';
import configurationStore from 'common/stores/configuration/configuration.store';
import { LiveActivityFeed } from 'common/components/live-activity/live-activity-feed';
import { Select } from 'antd';

export const EiqLiveActivity = observer(() => {
  const [locations, setLocations] = useState<any>([]);
  const [readers, setReaders] = useState<any>([]);

  const [selectedReader, setSelectedReader] = useState<string>('All');

  useEffect(() => {
    const options =
      configurationStore.configuration?.gates.map((g) => {
        return {
          label: g.name,
          value: g.name,
        };
      }) ?? [];

    setLocations([{ label: 'All', value: 'All' }, ...options]);

    eiqManageLiveActivityStore.init();
  }, []);

  const onLocationChanged = (value: any) => {
    setSelectedReader('All');
    eiqManageLiveActivityStore.setReader(null);

    const newValue = value === 'All' ? null : value;

    if (newValue) {
      const selectedGate = configurationStore.configuration?.gates.find((i) => i.name === newValue);

      const options =
        selectedGate?.readers?.map((r) => {
          return {
            label: r.name,
            value: r.number,
          };
        }) ?? [];

      setReaders([{ label: 'All', value: 'All' }, ...options]);
    } else {
      setReaders([]);
    }

    eiqManageLiveActivityStore.setLocation(newValue);
  };

  const onReaderChanged = (value: any) => {
    setSelectedReader(value);

    const newValue = value === 'All' ? null : value;
    eiqManageLiveActivityStore.setReader(newValue);
  };

  return (
    <LiveActivityFeed
      logs={eiqManageLiveActivityStore.logs}
      filter={
        <div className="location-wrapper">
          <span>Location</span>
          <Select defaultValue="All" options={locations} placeholder="Select location" onChange={onLocationChanged} />
          <span>Reader</span>
          <Select value={selectedReader} options={readers} placeholder="Select reader" onChange={onReaderChanged}></Select>
        </div>
      }
    />
  );
});
